import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { getRequest } from "../../../../utils/API/api.ts";
import { UPDATE_EVENT } from "../../../../redux/constants/eventConstants";
import FintechCard10 from "../cards/FintechCard10";
import FintechCard12 from "../cards/FintechCard12";
import FintechCard11 from "../cards/FintechCard11";
import FintechCard04 from "../cards/FintechCard04";
import LinkedinLinkClicks from "../linkedinCards/LinkedinLinkClicks";
import LinkedinPostCount from "../linkedinCards/LinkedinPostCount";
import LinkedinRegCount from "../linkedinCards/LinkedinRegCount";
import FintechCard09 from "../cards/FintechCard09";
import AnalyticsCard02 from "../cards/AnalyticsCard02";

function getDayWiseRegistrations(arr, eventId = null, entity) {
  if (arr.length === 0 || !eventId) {
    return [];
  }

  const resultsArray = [];

  for (let i = 0; i < arr.length; i++) {
    const ele = arr[i].attendee[0].eventSpecificData;
    for (let f = 0; f < ele.length; f++) {
      if (ele[f].eventId === eventId) {
        const utcDate = new Date(ele[f].timeStamp);
        const options = {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          timeZone: "Asia/Kolkata",
        };
        const dateString = utcDate.toLocaleDateString("en-IN", options);

        let obj = {
          date: dateString,
          registrations: 1,
        };

        let index = resultsArray.findIndex(
          (result) => result.date === dateString
        );

        if (index === 0 || index > -1) {
          resultsArray[index].registrations += 1;
        } else {
          resultsArray.push(obj);
        }
      }
    }
  }
  return resultsArray;
}

function getDetailedLabels(startDate, endDate) {
  const startDate1 = new Date(startDate);
  const endDate1 = new Date(endDate);
  const dateArray = [];
  let currentDate1 = startDate1;
  while (currentDate1 <= endDate1) {
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      timeZone: "Asia/Kolkata",
    };
    const dateString = currentDate1.toLocaleDateString("en-IN", options);
    dateArray.push(dateString);
    currentDate1.setDate(currentDate1.getDate() + 1);
  }
  return dateArray;
}

const MainAnalytics = React.memo(({ singleEvent }) => {
  const [state, setState] = useState({
    attendees: [],
    speakers: [],
    resultsArray: [],
    loadingAttendees: true,
    loadingSpeakers: true,
    loadingResults: true,
  });

  const dispatch = useDispatch();

  const getAllEventAttendees = useCallback(
    async (route) => {
      const response = await getRequest(route);
      if (response.data?.attendees?.length === 0) {
        setState((prevState) => ({
          ...prevState,
          loadingAttendees: false,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          attendees: response.data.attendees,
          loadingAttendees: false,
        }));
        dispatch({
          type: UPDATE_EVENT,
          payload: {
            attendees: response.data.attendees,
          },
        });
      }
    },
    [dispatch]
  );

  useEffect(() => {
    const fetchData = async () => {
      await getAllEventAttendees(`/attendee/${singleEvent?._id}?limit=0`);
      if (singleEvent._id) {
        setState((prevState) => ({
          ...prevState,
          speakers: singleEvent.speakers,
          loadingSpeakers: false,
        }));
      }
      if (state.attendees.length > 0 && singleEvent._id) {
        setState((prevState) => ({
          ...prevState,
          resultsArray: getDayWiseRegistrations(
            state.attendees,
            singleEvent._id,
            "attendees"
          ),
          loadingResults: false,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          loadingResults: false,
        }));
      }
    };
    if (singleEvent?._id) {
      fetchData();
    }
  }, [getAllEventAttendees, singleEvent._id, state.attendees.length]);

  const lineChartEndDate = singleEvent.endDate;

  const dateArray = useMemo(
    () => getDetailedLabels(singleEvent.createdAt, lineChartEndDate),
    [singleEvent.createdAt, lineChartEndDate]
  );

  return (
    <>
      {state.loadingAttendees ||
      state.loadingSpeakers ||
      state.loadingResults ? (
        <div className="md:w-full mt-[250px] flex justify-center items-center">
          <svg
            className="inline mr-2 w-11 h-11 text-gray-200 animate-spin dark:text-gray-600 fill-primary"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        </div>
      ) : (
        <div className="w-full md:ml-[0px] md:mt-[25px] min-h-[1260px] pb-[30px]">
          <div className="mt-[20px] flex justify-between">
            <FintechCard10
              resultsArray={state.resultsArray}
              dateArray={dateArray}
            />
            <FintechCard11 />
            <FintechCard12
              speakers={state.speakers}
              singleEvent={singleEvent}
            />
          </div>

          <div className="">
            <FintechCard04
              attendees={state.attendees}
              singleEvent={singleEvent}
              checkIns={true}
              checkOuts={false}
            />
          </div>

          <p className="font-[600] w-full mx-auto md:w-full text-[22px] text-black">
            Linkedin
          </p>

          <div className="mt-[20px] flex justify-between w-[500px] ">
            <LinkedinLinkClicks singleEvent={singleEvent} />
            <LinkedinPostCount singleEvent={singleEvent} />
            <LinkedinRegCount singleEvent={singleEvent} />
          </div>

          <div className="grid grid-cols-12 gap-[20px] mt-[40px]">
            <AnalyticsCard02 />
            <FintechCard09
              attendees={state.attendees}
              singleEvent={singleEvent}
            />
          </div>
        </div>
      )}
    </>
  );
});

export default MainAnalytics;
